<template>
  <el-button icon='el-icon-copy-document' @click='handleClick'>
    复制至{{ aim }}
  </el-button>
</template>
<script>
export default {
  name: 'ProductComponentCopy',
  props: {
    getProducts: {type: Function},
    cType: {type: Number},
  },
  computed: {
    aim() {
      return this.cType===1?'产品库':this.cType===2?'服饰库':'视频库'
    },
  },
  methods: {
    handleClick: function () {
      const products = this.getProducts()
      if (!Array.isArray(products) || products.length < 1) {
        this.$notify.warning('请选择要复制的商品')
        return
      }
      let dom = ''
      const ids = products.map((_, i) => {
        dom += `<div style='border-bottom: 1px solid #f2f2f2;padding: 4px 0;line-height: 1.2;'>${i + 1}.&nbsp;${_.title}</div>`
        return _.id
      })

      this.$confirm(
          `<div>
                    ${dom}
                    <H3>共计${ids.length}件商品</H3>
                  </div>`,
          `确认复制以下商品至${this.aim}吗?`,
          {
            iconClass: 'el',
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
      ).then(async () => {
        await this.$api.copyProduct({ids, c_type: this.cType})
        this.$message.success('操作成功')
        this.$emit('success')
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '放弃复制'
        })
      })
    }
  }
}
</script>
<style lang='scss'>
.product-transfer-container {

}
</style>
